import React, { Dispatch, SetStateAction } from 'react';
import { ShowContextProvider } from './ShowContext';
import ShowData from './ShowData';
import { ShowDataInstance } from './ShowTypes';

interface ControlledShowProps {
  children: React.ReactNode | React.ReactElement;
  data: Nullable<object>;
  setData?: Dispatch<SetStateAction<ShowDataInstance>>;
}

const ControlledShow = ({ children, data, setData }: ControlledShowProps) => {
  return (
    <ShowContextProvider
      value={{
        data: new ShowData(data || {}),
        setData,
      }}
    >
      {children}
    </ShowContextProvider>
  );
};

export default ControlledShow;
